import { ArrowRightThin } from '@ori-ui/icons';
import { useTheme } from '@ori-ui/mui';
import { generateSrcSet, getImageVariants } from '@ori/image-sizes-helper';
import useTestId from '@ori/testid-generator';
import { useCallback, useMemo, useLayoutEffect, useRef, useState } from 'react';
import { BANNER_ARROW, BANNER_CONTENT_WRAPPER, BANNER_IMAGE, BANNER_WRAPPER } from '../../common';
import { LazyImage } from '../LazyImage';
import { Content } from './Content';
import { ContentWrapper, ImageWrapper, LinkArrow, Root } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_IMAGE_WIDTH = 80;
export const Banner = props => {
  const {
    imageUrl,
    imageWidth = DEFAULT_IMAGE_WIDTH,
    url
  } = props;
  const {
    getTestId
  } = useTestId();
  const {
    palette
  } = useTheme();
  const imageWrapperRef = useRef(null);
  const [imageWrapperWidth, setImageWrapperWidth] = useState(0);
  const [imageWrapperHeight, setImageWrapperHeight] = useState(0);
  const lazyImageRef = useRef(null);
  const [lazyImageWidth, setLazyImageWidth] = useState(0);
  const [lazyImageHeight, setLazyImageHeight] = useState(0);
  const shouldWidthBeLarger = useMemo(() => imageWrapperWidth > imageWrapperHeight || lazyImageWidth < lazyImageHeight, [imageWrapperHeight, imageWrapperWidth, lazyImageHeight, lazyImageWidth]);
  const setLazyImageDimensions = useCallback(() => {
    if (lazyImageRef.current) {
      setLazyImageWidth(lazyImageRef.current.offsetWidth);
      setLazyImageHeight(lazyImageRef.current.offsetHeight);
    }
  }, []);
  useLayoutEffect(() => {
    if (imageWrapperRef.current) {
      setImageWrapperWidth(imageWrapperRef.current.offsetWidth);
      setImageWrapperHeight(imageWrapperRef.current.offsetHeight);
    }
  }, [setLazyImageDimensions]);
  const images = useMemo(() => imageUrl ? getImageVariants({
    url: imageUrl,
    backgroundColor: palette.grey[100],
    params: [{
      width: imageWidth,
      quality: 90
    }]
  }) : undefined, [imageUrl, imageWidth, palette.grey]);
  return /*#__PURE__*/_jsxs(Root, {
    href: url,
    "data-testid": getTestId(BANNER_WRAPPER),
    children: [images ? /*#__PURE__*/_jsx(ImageWrapper, {
      ref: imageWrapperRef,
      imageWidth: imageWidth,
      shouldWidthBeLarger: shouldWidthBeLarger,
      children: /*#__PURE__*/_jsx(LazyImage, {
        alt: imageUrl,
        imageRef: lazyImageRef,
        placeholderWidth: imageWidth,
        srcSet: generateSrcSet(images),
        sizes: `${imageWidth}px`,
        testId: getTestId(BANNER_IMAGE),
        onImageLoad: setLazyImageDimensions
      })
    }) : null, /*#__PURE__*/_jsx(ContentWrapper, {
      isUrlEmpty: !url,
      "data-testid": getTestId(BANNER_CONTENT_WRAPPER),
      children: /*#__PURE__*/_jsx(Content, {
        ...props
      })
    }), url ? /*#__PURE__*/_jsx(LinkArrow, {
      "data-testid": getTestId(BANNER_ARROW),
      children: /*#__PURE__*/_jsx(ArrowRightThin, {})
    }) : null]
  });
};
//# sourceMappingURL=Banner.js.map